import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { CircleCheck, CreditCard, Shield, Truck } from "lucide-react";
const summaryItems = [{
  icon: Shield,
  text: "DSGVO-Konforme Datenverarbeitung"
}, {
  icon: Truck,
  text: "Sichere SSL-Verschlüsselung"
}, {
  icon: CircleCheck,
  text: "Transparente Datennutzung"
}, {
  icon: CreditCard,
  text: "Rechtssichere Dokumentation"
}];
const policies = [{
  id: "privacy",
  title: "Datenschutzerklärung",
  content: <div className="max-w-2xl space-y-4 leading-relaxed text-foreground/80">
        <p>
          Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In diesen Datenschutzinformationen informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website.
        </p>
        <p>
          Wenn Sie per Formular auf der Website oder per E-Mail Kontakt mit uns aufnehmen, werden Ihre angegebenen Daten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen sechs Monate bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
        </p>
        <p>
          Sie können Ihre Präferenzen jederzeit in Ihren{" "}
          <Link to="/LegalNoticePage" className="text-primary hover:underline font-medium">
            Datenschutzeinstellungen
          </Link>{" "}
          anpassen.
        </p>
      </div>
}, {
  id: "refund",
  title: "Ihre Rechte",
  content: <div className="max-w-2xl space-y-4 leading-relaxed text-foreground/80">
        <p>
          Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt, können Sie sich bei uns oder der Aufsichtsbehörde beschweren.
        </p>
        <p>
          Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre durch uns verwalteten Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder gegen den Zugriff unberechtigter Personen zu schützen.
        </p>
        <p>
          Für detaillierte Anfragen nutzen Sie bitte unser{" "}
          <Link to="/LegalNoticePage" className="text-primary hover:underline font-medium">
            Kontaktformular
          </Link>{" "}
          oder schreiben Sie uns direkt.
        </p>
      </div>
}, {
  id: "shipping",
  title: "Cookies & Analyse",
  content: <div className="max-w-2xl space-y-4 leading-relaxed text-foreground/80">
        <p>
          Unsere Website verwendet so genannte Cookies. Dabei handelt es sich um kleine Textdateien, die mit Hilfe des Browsers auf Ihrem Endgerät abgelegt werden. Sie richten keinen Schaden an. Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten.
        </p>
        <p>
          Einige Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Sie ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen. Wenn Sie dies nicht wünschen, so können Sie Ihren Browser so einrichten, dass er Sie über das Setzen von Cookies informiert.
        </p>
        <p>
          Bei der Deaktivierung von Cookies kann die Funktionalität unserer Website eingeschränkt sein.
        </p>
      </div>
}, {
  id: "terms",
  title: "Haftungsausschluss",
  content: <div className="max-w-2xl space-y-4 leading-relaxed text-foreground/80">
        <p>
          Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
        </p>
        <p>
          Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter verantwortlich.
        </p>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet.
        </p>
      </div>
}];
export default function TheTransparencyReport() {
  return <section data-section-id="224310" id="data-protection-notice" className="w-full bg-background py-16 md:py-24 text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="mb-12">
          <h2 className="font-default text-3xl md:text-4xl font-bold tracking-tight text-foreground">
            Datenschutz & Transparenz
          </h2>
          <p className="mt-4 text-lg text-foreground/70 max-w-2xl">
            Klare, verständliche und ehrliche Richtlinien. Wir legen Wert auf vollständige Transparenz, damit Sie sich bei uns sicher fühlen können.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[320px_1fr] gap-10 lg:gap-16 items-start">
          <aside className="border border-border bg-card p-6 lg:sticky lg:top-24 rounded-lg shadow-md">
            <h3 className="font-default text-lg font-semibold text-foreground mb-6">
              Auf einen Blick
            </h3>
            <ul className="space-y-5">
              {summaryItems.map((item, i) => {
              const Icon = item.icon;
              return <li key={i} data-index={i} className="flex items-start gap-3">
                    <Icon className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                    <span className="text-sm font-medium text-foreground/80">
                      {item.text}
                    </span>
                  </li>;
            })}
            </ul>
            <div className="mt-8 pt-6 border-t border-border">
              <p className="text-sm text-foreground/60 mb-4">
                Haben Sie Fragen zum Datenschutz? Unser Team hilft Ihnen gerne weiter.
              </p>
              <Link to="/LegalNoticePage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all bg-primary text-primary-foreground shadow-sm hover:bg-primary/90 h-9 px-4 py-2 w-full">
                Kontakt aufnehmen
              </Link>
            </div>
          </aside>

          <div className="w-full">
            <Accordion type="single" collapsible className="w-full" defaultValue="privacy">
              {policies.map((policy, i) => <AccordionItem key={policy.id} value={policy.id} data-index={i} className="border-border">
                  <AccordionTrigger className="font-default text-lg font-semibold hover:no-underline hover:text-primary transition-colors py-6">
                    {policy.title}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6">
                    {policy.content}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}